(function () {
  'use strict';

  angular
    .module('indiCrewExpiryLog')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('indiCrewExpiryLog', {
        url: '/individual-crew-expiry-log',
        views : {
			'indiCrewExpiryLogView' : {
				templateUrl : 'indi-crew-expiry-log/views/indi-crew-expiry-log.tpl.html',
				controller : 'IndiCrewExpiryLogCtrl',
				controllerAs : 'indiCrewExpiryLog'
			}
		},
      });
  }
}());